// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___-Q-_","largestCol":"styles_largestCol__2gbeU","smallestCol":"styles_smallestCol__1sAnf"};